import { Box, Slider, Stack, Typography } from "@mui/material";

interface SliderFieldProps {
  label: string;
  min: number;
  max: number;
  step?: number;
  unit: string;
  value: number;
  onChange: (value: number) => void;
}

export default function SliderField({
  label,
  min,
  max,
  step = 1,
  unit,
  value,
  onChange,
}: SliderFieldProps) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography color="text.secondary" fontWeight={700}>
          {label}
        </Typography>
        <Typography color="secondary.main" fontWeight={800} whiteSpace="nowrap">
          {value} {unit}
        </Typography>
      </Stack>
      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(_, nextValue) => onChange(nextValue as number)}
        sx={{
          mt: 1,
          color: "primary.main",
          "& .MuiSlider-thumb": {
            border: "3px solid #fff",
            boxShadow: "0 2px 10px rgba(30, 53, 95, 0.2)",
          },
        }}
      />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="caption" color="text.secondary">
          {min} {unit}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {max} {unit}
        </Typography>
      </Stack>
    </Box>
  );
}
